import React from "react";
import { notification } from "antd";
import { faCheckCircle, faXmark, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const openNotificationWithIcon = (
  type = "success",
  message = "",
  description = "",
  duration = 4
) => {
  notification[type]({
    className: type === "success" ? "success-notification" : "error-notification",
    icon: <FontAwesomeIcon icon={type === 'success' ? faCheckCircle : faCircleXmark} />,
    closeIcon: <FontAwesomeIcon icon={faXmark} />,
    message,
    description,
    duration
  });
};
